import './index.scss';

// Abrir e fechar não moram aqui: o modal é do Bootstrap 3 (`.modal.fade`), e quem o abre é o CTA do
// card bloqueado, via `ModalManager.open` em
// `components/weekly_errors_notebook_card/index.js#openPaywall`. Backdrop, ESC, clique-fora, scroll
// lock e retorno de foco vêm do próprio Bootstrap. Este arquivo só emite analytics.
export const MODAL_SELECTOR = '#js-weekly-errors-paywall-modal';
export const CTA_SELECTOR = '#js-weekly-errors-paywall-modal-cta';
export const FEATURE_NAME = 'Caderno de Erros da Semana';

// O enum de `source notebook error generated` (GERE3-7) não é emitido por este Cell: quem o carrega
// é o CARD, no `data-weekly-errors-source`, preenchido a partir da view. Ler de lá evita passar o
// mesmo param para dois Cells em três views.
//
// É seguro: o card é o ÚNICO caminho que abre este modal (`openPaywall` no index.js dele), e o card
// bloqueado nunca é removido do DOM — quando estes handlers rodam, o atributo está lá. O fallback
// vazio cobre uma abertura por outro caminho no futuro.
export const SOURCE_ATTR = 'data-weekly-errors-source';

function source() {
  const card = document.querySelector(`[${SOURCE_ATTR}]`);

  return card ? card.getAttribute(SOURCE_ATTR) : '';
}

export function emit(eventName) {
  if (!window.UserTracker) {
    return;
  }

  window.UserTracker.emit('event', {
    eventName: eventName,
    data: {
      'feature name': FEATURE_NAME,
      'source platform': 'portal',
      'source project': 'odin',
      'source notebook error generated': source()
    }
  });
}

(function ($) {
  'use strict';

  // Delegados em `document` porque o markup do Cell pode ser reinserido por visita Turbolinks.
  //
  // ! O `.off()` antes de cada `.on()` NÃO é cerimônia — é o que impede o evento de ser contado N
  // vezes. Este módulo vive nos packs de PÁGINA (`pages/questions`, `pages/user_dashboard`), e só o
  // pack `application` carrega com `data-turbolinks-eval="false"` (`shared/_footer_content`): os de
  // página são reavaliados a cada visita, reexecutando este arquivo. O sweeper de
  // `utils/turbolinks` não salva, porque a condição dele (`el !== document`) exclui justamente o
  // `document`. Medido aqui: sem o `.off()`, os handlers iam a 1 → 2 → 3 → 4 navegando entre o
  // Painel e Questões, e UMA abertura do modal emitia QUATRO eventos.
  //
  // O namespace é composto porque o evento do Bootstrap já traz o dele: `shown.bs.modal` tem tipo
  // `shown` e namespaces `bs`+`modal`. Somando o nosso, o `.off()` alcança só quem tem os três — os
  // listeners do próprio Bootstrap e de terceiros no mesmo evento ficam de pé.
  const NS = 'weeklyErrorsPaywallModal';

  // DOIS nomes por gatilho, de propósito. Os `upgrade modal *` são os do `not_elite_user_modal` e
  // mantêm os dois paywalls no mesmo funil genérico; os `notebook error modal *` são os do GERE3-7 e
  // medem só esta feature, junto com os do card. Nenhum dos dois conjuntos substitui o outro.
  //
  // `hidden.bs.modal` cobre "Agora não", o ESC e o clique fora numa regra só. O CTA é um `<a>` com
  // navegação nativa, então não dispara esse evento — daí o handler separado, e é por isso que
  // clicar no CTA não conta uma dispensa junto.
  $(document)
    .off(`shown.bs.modal.${NS}`, MODAL_SELECTOR)
    .on(`shown.bs.modal.${NS}`, MODAL_SELECTOR, () =>
      emit('upgrade modal viewed')
    );

  $(document)
    .off(`hidden.bs.modal.${NS}`, MODAL_SELECTOR)
    .on(`hidden.bs.modal.${NS}`, MODAL_SELECTOR, () => {
      emit('upgrade modal dismissed');
      emit('notebook error modal dismissed');
    });

  $(document)
    .off(`click.${NS}`, CTA_SELECTOR)
    .on(`click.${NS}`, CTA_SELECTOR, () => {
      emit('upgrade modal cta clicked');
      emit('notebook error modal cta clicked');
    });
})(jQuery);
